
export default ({
  name: 'App',
});
